import { combineReducers } from 'redux';
import userReducer from './UserReducer';
import applyReducer from './ApplyReducer';
import jobReducer from './JobReducer';
import windowReducer from './WindowReducer';
import contextReducer from './ContextReducer';
import FilterReducer from './SnbReducer/filter';
import SnbReducer from './SnbReducer';
import jobSearchReducer from './JobSearchReducer';
import featureReducer from './JobsPostAdReducer/featureReducer';
import jobsPostAdRequestReducer from './JobsPostAdReducer/jobsPostAdRequestReducer';
import ConfigReducer from './ConfigReducer';
import IntegrationsReducer from './IntegrationsReducer';
import ProfileReducer from './ProfileReducer';
import CompanyReducer from './CompanyReducer';
import FlexiCandidateReducer from './FlexiCandidateReducer';
import FlexiRecruiterReducer from './FlexiRecruiterReducer';
import CandidateTestReducer from './CandidateTestReducer';


export const reducers = combineReducers({
  config: ConfigReducer,
  user: userReducer,
  apply: applyReducer,
  job: jobReducer,
  window: windowReducer,
  context: contextReducer,
  snb: SnbReducer,
  filter: FilterReducer,
  jobSearch: jobSearchReducer,
  jobsPostAdFeature: featureReducer,
  postAdRequest: jobsPostAdRequestReducer,
  integrationsForm: IntegrationsReducer,
  profile: ProfileReducer,
  company: CompanyReducer,
  flexiCandidate: FlexiCandidateReducer,
  flexiRecruiter: FlexiRecruiterReducer,
  candidateTest: CandidateTestReducer
});



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/index.js